const menuMobileDom = document.querySelector('.burger__menu');
const navContainerDom = document.querySelector('.nav__container');
const closerDom = document.querySelector('.nav__container .closer');

function initMenuMobile() {
  if (menuMobileDom !== null) {
    menuMobileDom.addEventListener('click', (e) => {
      const menu = e.currentTarget;
      navContainerDom.classList.remove('out');
      navContainerDom.classList.add('active');
    });
    closerDom.addEventListener('click', (e) => {
      const closer = e.currentTarget;
      navContainerDom.classList.add('out');
      setTimeout(() => {
        navContainerDom.classList.remove('active');
      }, 250);
    });
  }
}

export default initMenuMobile;
